export const gossipTopics = [
  { rank: 1, title: "杀青宴同框画面引发讨论", heat: 3284000, trend: "up", categorySlug: "entertainment-gossip" },
  { rank: 2, title: "巡演加场开票十分钟售罄", heat: 2912000, trend: "up", categorySlug: "star-news" },
  { rank: 3, title: "话题词条一夜冲上榜单", heat: 2645000, trend: "new", categorySlug: "hot-topics" },
  { rank: 4, title: "悬疑剧叙事节奏之争", heat: 2103000, trend: "up", categorySlug: "film-tv" },
  { rank: 5, title: "新专辑预热造型转变", heat: 1876000, trend: "down", categorySlug: "star-news" },
  { rank: 6, title: "音乐节直播混音被吐槽", heat: 1620000, trend: "up", categorySlug: "music-live" },
  { rank: 7, title: "跨界联名上架即被抢空", heat: 1488000, trend: "down", categorySlug: "hot-topics" },
  { rank: 8, title: "慢综艺改版首播口碑", heat: 1223000, trend: "new", categorySlug: "film-tv" },
  { rank: 9, title: "暑期档片单密集定档", heat: 986000, trend: "down", categorySlug: "film-tv" },
  { rank: 10, title: "小场巡演一小时内售罄", heat: 812000, trend: "new", categorySlug: "music-live" },
];